<template>
  <!-- 根容器，用于渲染路由匹配的组件 -->
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'App',
  // 子组件注册（当前无子组件）
  components: {
  },
  mounted() {
    // 全局监听被挤下线事件（单设备登录控制）
    // 确保在任何页面都能响应被挤下线通知
    window.addEventListener('sessionKickedOut', this._onSessionKickedOut);
  },
  beforeDestroy() {
    window.removeEventListener('sessionKickedOut', this._onSessionKickedOut);
  },
  methods: {
    _onSessionKickedOut(event) {
      const msg = (event && event.detail && event.detail.message) || '您的账号已在其他设备登录，当前登录已失效';
      alert(msg);
      // 跳转到首页（仅在非首页时跳转）
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    }
  }
}
</script>

<style>
/* 应用全局样式 */
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Microsoft YaHei', 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* 移动端强制重置 - 覆盖 View UI Plus 组件库默认样式 */
@media (max-width: 768px) {
  body {
    padding-top: 0 !important;
    margin-top: 0 !important;
    top: 0 !important;
  }

  #app {
    padding-top: 0 !important;
    margin-top: 0 !important;
    top: 0 !important;
  }

  /* 强制重置所有可能的间距元素 */
  .full-page-content,
  .main-content,
  .mobile-header-title,
  .mobile-header-title h2 {
    margin-top: 0 !important;
    padding-top: 0 !important;
    top: 0 !important;
  }
}

/* 路由视图全页面布局 */
#app > .router-view-wrapper {
  flex: 1;
  width: 100%;
  min-height: 100vh;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
  transition: all 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
}

/* 全局动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.fade-in {
  animation: fadeIn 0.5s ease-out;
}

.slide-in {
  animation: slideIn 0.5s ease-out;
}
</style>